import React, { useState, Children } from 'react';
import { Calculator, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function CCSCalculator() {
  const [income, setIncome] = useState<number>(120000);
  const [children, setChildren] = useState<number>(1);
  const [days, setDays] = useState<number>(3);
  const [calculated, setCalculated] = useState(false);
  const dailyRate = 118;
  const calculateSubsidy = () => {
    let subsidyPercent = 0;
    if (income < 80594) subsidyPercent = 0.9;else if (income <= 190000) subsidyPercent = 0.75;else if (income <= 530000) subsidyPercent = 0.5;else subsidyPercent = 0;
    const outOfPocketDaily = dailyRate * (1 - subsidyPercent);
    const outOfPocketWeekly = outOfPocketDaily * days;
    return {
      daily: outOfPocketDaily.toFixed(2),
      weekly: outOfPocketWeekly.toFixed(2),
      percent: (subsidyPercent * 100).toFixed(0)
    };
  };
  const handleCalculate = (e: React.FormEvent) => {
    e.preventDefault();
    setCalculated(true);
    console.log('Track: ccs_calculator_use');
  };
  const result = calculateSubsidy();
  return <section id="ccs-calculator" className="py-20 md:py-32 px-6 bg-navy relative overflow-hidden" data-id="element-39">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-40">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-blue/30 rounded-full blur-3xl" data-id="element-41"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-teal/20 rounded-full blur-3xl" data-id="element-42"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-43">
        <div className="text-center mb-16" data-id="element-44">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 tracking-tight" data-id="element-45">
            Understand your out-of-pocket cost in 90 seconds.
          </h2>
          <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto font-medium" data-id="element-46">
            Funtastic Kidz is CCS approved. Your subsidy depends on family
            income, activity hours, child's age, and CCS eligibility.
          </p>
        </div>

        <div className="bg-white rounded-[32px] shadow-2xl overflow-hidden border-4 border-white/10" data-id="element-47">
          <div className="grid md:grid-cols-2" data-id="element-48">
            {/* Input Side */}
            <div className="p-8 md:p-12 border-b md:border-b-0 md:border-r border-sand bg-white" data-id="element-49">
              <form onSubmit={handleCalculate} className="space-y-8" data-id="element-50">
                <div className="space-y-4" data-id="element-51">
                  <div className="flex justify-between items-center" data-id="element-52">
                    <label htmlFor="income" className="font-extrabold text-navy text-lg" data-id="element-53">
                      Family combined income
                    </label>
                    <span className="text-coral font-extrabold text-xl" data-id="element-54">
                      ${income.toLocaleString()}
                    </span>
                  </div>
                  <input type="range" id="income" min="0" max="550000" step="5000" value={income} onChange={e => {
                  setIncome(Number(e.target.value));
                  setCalculated(false);
                }} className="w-full h-3 bg-sand rounded-lg appearance-none cursor-pointer accent-coral" data-id="element-55" />
                  <div className="flex justify-between text-xs text-navy/50 font-bold uppercase tracking-wider" data-id="element-56">
                    <span data-id="element-57">$0</span>
                    <span data-id="element-58">$530k+</span>
                  </div>
                </div>

                <div className="space-y-4" data-id="element-59">
                  <label className="font-extrabold text-navy text-lg block" data-id="element-60">
                    Number of children in care
                  </label>
                  <div className="flex gap-3" data-id="element-61">
                    {[1, 2, 3, 4, 5].map(num => <button key={`child-${num}`} type="button" onClick={() => {
                    setChildren(num);
                    setCalculated(false);
                  }} className={`flex-1 h-14 rounded-xl border-2 font-bold text-lg transition-all ${children === num ? 'bg-blue text-white border-blue shadow-md transform scale-[1.02]' : 'bg-cream border-sand text-navy hover:border-blue/30 hover:bg-white'}`} data-id="element-62">
                        {num}
                      </button>)}
                  </div>
                </div>

                <div className="space-y-4" data-id="element-63">
                  <label className="font-extrabold text-navy text-lg block" data-id="element-64">
                    Days per week
                  </label>
                  <div className="flex gap-3" data-id="element-65">
                    {[1, 2, 3, 4, 5].map(num => <button key={`day-${num}`} type="button" onClick={() => {
                    setDays(num);
                    setCalculated(false);
                  }} className={`flex-1 h-14 rounded-xl border-2 font-bold text-lg transition-all ${days === num ? 'bg-teal text-white border-teal shadow-md transform scale-[1.02]' : 'bg-cream border-sand text-navy hover:border-teal/30 hover:bg-white'}`} data-id="element-66">
                        {num}
                      </button>)}
                  </div>
                </div>

                <button type="submit" className="w-full bg-coral text-white h-16 rounded-btn font-extrabold text-lg hover:bg-red transition-colors flex items-center justify-center gap-3 shadow-lg hover:shadow-xl hover:-translate-y-1 transform duration-200 mt-4" data-id="element-67">
                  <Calculator size={24} data-id="element-68" />
                  Calculate Estimate
                </button>
              </form>
            </div>

            {/* Result Side */}
            <div className="p-8 md:p-12 bg-blue-deep flex flex-col justify-center relative overflow-hidden" data-id="element-69">
              <div className="absolute top-0 right-0 w-64 h-64 bg-blue rounded-full blur-3xl opacity-50 -z-10" data-id="element-70"></div>

              {calculated ? <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="space-y-8 z-10" data-id="element-71">
                  <div className="text-center bg-white/10 backdrop-blur-md border border-white/20 p-8 rounded-[24px] shadow-xl" data-id="element-72">
                    <p className="text-white/80 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-73">
                      Estimated weekly out-of-pocket
                    </p>
                    <div className="text-6xl md:text-7xl font-extrabold text-yellow mb-2 drop-shadow-lg" data-id="element-74">
                      ${result.weekly}
                    </div>
                    <p className="text-sm font-medium text-white/70" data-id="element-75">
                      For {children} child(ren), {days} days a week
                    </p>
                  </div>

                  <div className="bg-white/5 backdrop-blur-sm p-6 rounded-[20px] border border-white/10 space-y-4" data-id="element-76">
                    <div className="flex justify-between text-sm font-medium" data-id="element-77">
                      <span className="text-white/70" data-id="element-78">Full daily rate</span>
                      <span className="text-white" data-id="element-79">
                        ${dailyRate.toFixed(2)}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm font-medium" data-id="element-80">
                      <span className="text-white/70" data-id="element-81">
                        Estimated CCS ({result.percent}%)
                      </span>
                      <span className="text-teal" data-id="element-82">
                        -${(dailyRate - Number(result.daily)).toFixed(2)} / day
                      </span>
                    </div>
                    <div className="pt-4 border-t border-white/10 flex justify-between font-extrabold text-lg" data-id="element-83">
                      <span className="text-white" data-id="element-84">Your daily rate</span>
                      <span className="text-yellow" data-id="element-85">${result.daily}</span>
                    </div>
                  </div>

                  <div className="space-y-4 pt-2" data-id="element-86">
                    <a href="#tours" className="block w-full bg-white text-blue-deep text-center py-4 rounded-btn font-extrabold text-lg hover:bg-sand transition-colors shadow-lg" data-id="element-87">
                      Book a tour to discuss
                    </a>
                    <a href="https://www.servicesaustralia.gov.au/child-care-subsidy" target="_blank" rel="noopener noreferrer" className="block w-full bg-transparent border-2 border-white/30 text-white text-center py-4 rounded-btn font-bold hover:bg-white/10 transition-colors" data-id="element-88">
                      Calculate exact at Services Australia
                    </a>
                  </div>
                  <p className="text-xs text-white/50 text-center font-medium leading-relaxed" data-id="element-89">
                    This is an illustrative estimate only. Actual subsidy
                    depends on your specific circumstances assessed by Services
                    Australia.
                  </p>
                </motion.div> : <div className="text-center text-white/40 flex flex-col items-center justify-center h-full min-h-[400px] z-10" data-id="element-90">
                  <Calculator size={64} className="mb-6 opacity-30" strokeWidth={1.5} data-id="element-91" />
                  <p className="font-bold text-lg max-w-xs" data-id="element-92">
                    Adjust the sliders and click calculate to see your estimated
                    out-of-pocket costs.
                  </p>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}